import React from "react";
import { Link } from "react-router-dom";

const BlogCard = ({slug,img,title,desc,date}) => {
  return (
    <>
      <div className="single-blog shadow">
        <div style={{height:"327px"}} className="inner-blog ">
          <div className="blog-img" style={{height:"200px"}}>
            <Link to={`/blog/${slug}`} className="cate" style={{ marginRight:"10px"}}>
              {date}
            </Link>
            <img src={img} width={305} style={{objectFit:"cover",height:"100%"}} height={200} alt={title} />
          </div>
          <div className="blog-content">
            {/* <ul className="top-part">
                                                    <li>
                                                        <img src={require(`../../assets/images/course/${data.authorImg}`)} alt="user" /> {data.author}
                                                    </li>
                                                    <li className="date-part">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-clock"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg> {data.publishedDate}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg> {data.totalView} views
                                                    </li>
                                                </ul> */}

            <h3 className="blog-title">
              <Link to={`/blog/${slug}`}>{title}</Link>
            </h3>
            <p className="blog-desc">{desc}</p>
            {/* <div className="button__sec">
                                                    <Link to={`/blog/${data.id}`} className="blog-btn">Read More <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></Link>
                                                    <div className="share-course">
                                                        Post Share <em><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-share-2"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg></em>
                                                        <span>
                                                            <Link to="#"><i aria-hidden="true" className="social_facebook"></i></Link>
                                                            <Link to="#"><i aria-hidden="true" className="social_twitter"></i></Link>
                                                            <Link to="#"><i aria-hidden="true" className="social_linkedin"></i></Link>
                                                        </span>
                                                    </div>
                                                </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogCard;
